"use strict";
// --------------------------------------------------------------------------------------------------------------------
// <copyright file="Account.ts" company="Microsoft">
//   Copyright (c) Microsoft Corporation.  All rights reserved.
// </copyright>
// <summary>
//   TypeScript implementation of the HxAccount object
//   THIS FILE IS GENERATED BY A TOOL -- OBJECTGEN, DO NOT EDIT BY HAND
// </summary>
// --------------------------------------------------------------------------------------------------------------------
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HxAccount = void 0;
var HxObject_1 = __importDefault(require("./HxObject"));
var HxObjectID_1 = __importDefault(require("./HxObjectID"));
var HxObjectType_1 = __importDefault(require("./HxObjectType"));
var HxDailySetting_1 = require("./HxDailySetting");
var HxPauseSetting_1 = require("./HxPauseSetting");
var HxStringPair_1 = require("./HxStringPair");
var HxAccount = /** @class */ (function (_super) {
    __extends(HxAccount, _super);
    function HxAccount(objectId, storageSequenceNumber, obj, activeSet) {
        var _this = _super.call(this, objectId, HxObjectType_1.default.HxAccount, storageSequenceNumber, activeSet) || this;
        _this.update(obj);
        return _this;
    }
    HxAccount.prototype.update = function (obj) {
        var e_1, _a;
        try {
            for (var _b = __values(Object.entries(obj)), _c = _b.next(); !_c.done; _c = _b.next()) {
                var _d = __read(_c.value, 2), key = _d[0], v = _d[1];
                switch (key) {
                    case '1':
                        this.objectId = new HxObjectID_1.default(v);
                        break;
                    case '2':
                        this.parentId = new HxObjectID_1.default(v);
                        break;
                    case '14D8':
                        this.aadLogoDarkId = new HxObjectID_1.default(v);
                        break;
                    case '1526':
                        this.aadLogoLastAttemptedUpdateTime = new Date(v);
                        break;
                    case '14DA':
                        this.aadLogoLightId = new HxObjectID_1.default(v);
                        break;
                    case 'BBF':
                        this.abqHtmlErrorMessage = v;
                        break;
                    case 'A8B':
                        this.accessToken = Buffer.from(v, 'base64');
                        break;
                    case 'A8C':
                        this.accessTokenExpiration = new Date(v);
                        break;
                    case '105C':
                        this.actionsQueued = v;
                        break;
                    case '155E':
                        this.activityFeedDataId = new HxObjectID_1.default(v);
                        break;
                    case '155F':
                        this.activityFeedNotificationWatermarkCounter = v;
                        break;
                    case '1560':
                        this.activityFeedNotificationWatermarkSessionId = v;
                        break;
                    case '157E':
                        this.activityFeedUnseenCount = v;
                        break;
                    case '10CC':
                        this.addInsId = new HxObjectID_1.default(v);
                        break;
                    case '1136':
                        this.addInsLastUpdate = new Date(v);
                        break;
                    case '15AA':
                        this.adsTargetingOptOut = v;
                        break;
                    case '14CB':
                        this.advertisingSettingLastUpdate = new Date(v);
                        break;
                    case 'A13':
                        this.anchorMailbox = v;
                        break;
                    case 'C13':
                        this.attachmentsId = new HxObjectID_1.default(v);
                        break;
                    case '15D4':
                        this.autoReplyConfigurationLastUpdate = new Date(v);
                        break;
                    case 'EEF':
                        this.azureFrontDoorUrl = v;
                        break;
                    case '12CD':
                        this.badgeCount = v;
                        break;
                    case '1271':
                        this.badgeCountAccountId = v;
                        break;
                    case '1315':
                        this.beginSyncWipeWatermark = v;
                        break;
                    case '109E':
                        this.blockedSenderAndDomainListLastUpdate = new Date(v);
                        break;
                    case '109F':
                        this.blockedSendersAndDomainsId = new HxObjectID_1.default(v);
                        break;
                    case '38':
                        this.calendarId = new HxObjectID_1.default(v);
                        break;
                    case 'A98':
                        this.calendarNeedsTickle = v;
                        break;
                    case 'D67':
                        this.categoriesId = new HxObjectID_1.default(v);
                        break;
                    case '143A':
                        var certificateOrderListValues = v;
                        this.certificateOrderList = new Array(certificateOrderListValues.length);
                        for (var i = 0; i < certificateOrderListValues.length; i++) {
                            this.certificateOrderList[i] = certificateOrderListValues[i];
                        }
                        break;
                    case 'F87':
                        this.complianceConfigurationLastUpdate = new Date(v);
                        break;
                    case '634':
                        this.contactId = new HxObjectID_1.default(v);
                        break;
                    case '4D':
                        this.contactListDeviceId = v;
                        break;
                    case '137B':
                        this.contactNotificationWatermarkCounter = v;
                        break;
                    case '137C':
                        this.contactNotificationWatermarkSessionId = v;
                        break;
                    case 'E93':
                        this.contactsLastUpdate = new Date(v);
                        break;
                    case 'A99':
                        this.contactsNeedsTickle = v;
                        break;
                    case 'FA9':
                        this.coordinatedUnreadCountEnabled = v;
                        break;
                    case '1411':
                        this.countryOrRegion = v;
                        break;
                    case 'D13':
                        this.currentRSAKeyTimestamp = new Date(v);
                        break;
                    case '4C':
                        this.dataType = v;
                        break;
                    case '10A9':
                        this.delegatesPermissionsLastUpdate = new Date(v);
                        break;
                    case '10AA':
                        this.delegateUsersId = new HxObjectID_1.default(v);
                        break;
                    case 'A15':
                        this.deprovisionStatus = v;
                        break;
                    case '44':
                        this.deviceId = v;
                        break;
                    case '34':
                        this.displayName = v;
                        break;
                    case '102F':
                        var doNotDisturbSettings_DailySettingsValues = v;
                        this.doNotDisturbSettings_DailySettings = new Array(doNotDisturbSettings_DailySettingsValues.length);
                        for (var i = 0; i < doNotDisturbSettings_DailySettingsValues.length; i++) {
                            this.doNotDisturbSettings_DailySettings[i] = HxDailySetting_1.deserializeHxDailySetting(doNotDisturbSettings_DailySettingsValues[i]);
                        }
                        break;
                    case '1030':
                        this.doNotDisturbSettings_EnabledDuringEvents = v;
                        break;
                    case '1031':
                        this.doNotDisturbSettings_EndTimeUtc = new Date(v);
                        break;
                    case '10EE':
                        this.doNotDisturbSettings_EventSettingLastModifiedTimeUtc = new Date(v);
                        break;
                    case '1519':
                        this.doNotDisturbSettings_HideBadgeCount = v;
                        break;
                    case '1032':
                        var doNotDisturbSettings_PauseSettingsValues = v;
                        this.doNotDisturbSettings_PauseSettings = new Array(doNotDisturbSettings_PauseSettingsValues.length);
                        for (var i = 0; i < doNotDisturbSettings_PauseSettingsValues.length; i++) {
                            this.doNotDisturbSettings_PauseSettings[i] = HxPauseSetting_1.deserializeHxPauseSetting(doNotDisturbSettings_PauseSettingsValues[i]);
                        }
                        break;
                    case 'A16':
                        this.easPoliciesId = new HxObjectID_1.default(v);
                        break;
                    case '2E':
                        this.emailAddress = v;
                        break;
                    case '14CC':
                        this.encodedTC = v;
                        break;
                    case '3D9':
                        this.enterpriseID = v;
                        break;
                    case '5B':
                        this.errorsId = new HxObjectID_1.default(v);
                        break;
                    case '3D6':
                        this.eventsFromEmailProviderSettings_DiningEventsFromEmailEnabled = v;
                        break;
                    case '3D7':
                        this.eventsFromEmailProviderSettings_EntertainmentEventsFromEmailEnabled = v;
                        break;
                    case '3D1':
                        this.eventsFromEmailProviderSettings_EventsFromEmailEnabled = v;
                        break;
                    case '3D2':
                        this.eventsFromEmailProviderSettings_FlightEventsFromEmailEnabled = v;
                        break;
                    case '3D3':
                        this.eventsFromEmailProviderSettings_HotelEventsFromEmailEnabled = v;
                        break;
                    case '3D5':
                        this.eventsFromEmailProviderSettings_PackageDeliveryEventsFromEmailEnabled = v;
                        break;
                    case '3D4':
                        this.eventsFromEmailProviderSettings_RentalCarEventsFromEmailEnabled = v;
                        break;
                    case '6A0':
                        this.externalDataFolderId = v;
                        break;
                    case 'FB9':
                        this.favoriteItemsId = new HxObjectID_1.default(v);
                        break;
                    case 'E95':
                        this.favoritesListLastUpdate = new Date(v);
                        break;
                    case 'B43':
                        this.firstDataReplicationFinished = v;
                        break;
                    case 'B44':
                        this.firstDataReplicationFinishedWatermark = v;
                        break;
                    case '15AB':
                        this.firstPartyCookieOptOut = v;
                        break;
                    case 'A6A':
                        this.firstSyncId = new HxObjectID_1.default(v);
                        break;
                    case 'A1A':
                        this.focusedInboxLastUpdate = new Date(v);
                        break;
                    case '127A':
                        var gatewayCommandsValues = v;
                        this.gatewayCommands = new Array(gatewayCommandsValues.length);
                        for (var i = 0; i < gatewayCommandsValues.length; i++) {
                            this.gatewayCommands[i] = gatewayCommandsValues[i];
                        }
                        break;
                    case 'C7A':
                        this.groupsId = new HxObjectID_1.default(v);
                        break;
                    case 'CD6':
                        this.groupSettingsId = new HxObjectID_1.default(v);
                        break;
                    case 'E53':
                        this.groupSettingsLastAttemptedSyncTime = new Date(v);
                        break;
                    case 'DBB':
                        this.groupsUnreadCount = v;
                        break;
                    case '1464':
                        this.h2Anid = v;
                        break;
                    case '1114':
                        this.hasManagedAlias = v;
                        break;
                    case '119C':
                        this.hasMobilePresence = v;
                        break;
                    case 'AFF':
                        this.hidden = v;
                        break;
                    case '10B5':
                        this.inferredLocationsLastUpdate = new Date(v);
                        break;
                    case 'ACA':
                        this.instanceId = v;
                        break;
                    case '54':
                        this.isCalendarCapable = v;
                        break;
                    case 'F3B':
                        this.isCloudCache = v;
                        break;
                    case 'FD2':
                        this.isContactsCapable = v;
                        break;
                    case 'E21':
                        this.isEasiId = v;
                        break;
                    case '15DD':
                        this.isEdu = v;
                        break;
                    case '608':
                        this.isExternallyManaged = v;
                        break;
                    case 'A1B':
                        this.isFocusedInboxEnabled = v;
                        break;
                    case 'ED9':
                        this.isGCCRestrictionsEnabled = v;
                        break;
                    case '7D2':
                        this.isHolidayCalendarsAccount = v;
                        break;
                    case 'AFE':
                        this.isHxSCapable = v;
                        break;
                    case 'F40':
                        this.isInitialized = v;
                        break;
                    case '53':
                        this.isMailCapable = v;
                        break;
                    case 'AD2':
                        this.isMailOrCalendarCapable = v;
                        break;
                    case 'F1D':
                        this.isMigratedByExperiment = v;
                        break;
                    case '14CF':
                        this.isMobileAppEducationEnabled = v;
                        break;
                    case '12A3':
                        this.isNewMailNotificationEncryptionEnforcedByTenant = v;
                        break;
                    case '3ED':
                        this.isProtectedUnderLock = v;
                        break;
                    case 'DCF':
                        this.isRemoteWipeRequested = v;
                        break;
                    case 'EDA':
                        this.isSingleAccountEnabled = v;
                        break;
                    case 'D94':
                        this.isUninitialized = v;
                        break;
                    case 'A1C':
                        this.isWaitingForFirstShadowMail = v;
                        break;
                    case 'EE9':
                        this.isWorkingOffline = v;
                        break;
                    case 'F3D':
                        this.lastAADClaimsChallenge = v;
                        break;
                    case 'F3E':
                        this.lastAuthenticationChallenge = v;
                        break;
                    case 'E2D':
                        this.lastGroupViewAccessed = v;
                        break;
                    case 'A89':
                        this.lastPollTime = new Date(v);
                        break;
                    case '14E1':
                        this.lastWebDavSimulatedPushNoticationPollTime = new Date(v);
                        break;
                    case '1510':
                        this.ldapServerSettingsId = new HxObjectID_1.default(v);
                        break;
                    case '35A':
                        this.linkedInboxDeviceId = v;
                        break;
                    case '7A0':
                        this.localUdaStatus = v;
                        break;
                    case '37':
                        this.mailId = new HxObjectID_1.default(v);
                        break;
                    case '12FD':
                        this.mailAccountLocalSettings_AllowSMIMECertificatesWithoutMatchingEmailAddress = v;
                        break;
                    case '656':
                        this.mailAccountLocalSettings_AlwaysEncrypt = v;
                        break;
                    case '655':
                        this.mailAccountLocalSettings_AlwaysSign = v;
                        break;
                    case 'F99':
                        this.mailAccountLocalSettings_ClearSignSignedMessages = v;
                        break;
                    case '65B':
                        this.mailAccountLocalSettings_ConversationViewMode = v;
                        break;
                    case 'E25':
                        this.mailAccountLocalSettings_DefaultFontHtml = Buffer.from(v, 'base64');
                        break;
                    case 'F9A':
                        this.mailAccountLocalSettings_EncryptingAlgorithm = v;
                        break;
                    case '658':
                        this.mailAccountLocalSettings_EncryptingCertificateHash = Buffer.from(v, 'base64');
                        break;
                    case 'FB5':
                        this.mailAccountLocalSettings_IncludeChainCertsInMessage = v;
                        break;
                    case 'E26':
                        this.mailAccountLocalSettings_IsDefaultFontUserModified = v;
                        break;
                    case '654':
                        this.mailAccountLocalSettings_IsExternalContentEnabled = v;
                        break;
                    case '64E':
                        this.mailAccountLocalSettings_IsSignatureEnabled = v;
                        break;
                    case '64D':
                        this.mailAccountLocalSettings_IsSignatureUserModified = v;
                        break;
                    case 'D65':
                        this.mailAccountLocalSettings_IsSMIMEExternalContentEnabled = v;
                        break;
                    case '64F':
                        this.mailAccountLocalSettings_QuickActionPrimary = v;
                        break;
                    case '650':
                        this.mailAccountLocalSettings_QuickActionSecondary = v;
                        break;
                    case '6D9':
                        this.mailAccountLocalSettings_SignatureHtml = Buffer.from(v, 'base64');
                        break;
                    case 'B6B':
                        var mailAccountLocalSettings_SignatureImagesValues = v;
                        this.mailAccountLocalSettings_SignatureImages = new Array(mailAccountLocalSettings_SignatureImagesValues.length);
                        for (var i = 0; i < mailAccountLocalSettings_SignatureImagesValues.length; i++) {
                            this.mailAccountLocalSettings_SignatureImages[i] = HxStringPair_1.deserializeHxStringPair(mailAccountLocalSettings_SignatureImagesValues[i]);
                        }
                        break;
                    case 'F9B':
                        this.mailAccountLocalSettings_SigningAlgorithm = v;
                        break;
                    case '657':
                        this.mailAccountLocalSettings_SigningCertificateHash = Buffer.from(v, 'base64');
                        break;
                    case 'A1D':
                        this.mailbox = v;
                        break;
                    case '45':
                        this.mailboxDeviceId = v;
                        break;
                    case 'A9A':
                        this.mailNeedsTickle = v;
                        break;
                    case '1579':
                        this.mailSubscriptionListId = new HxObjectID_1.default(v);
                        break;
                    case '157A':
                        this.mailSubscriptionListLastUpdateTime = new Date(v);
                        break;
                    case 'B00':
                        this.markedForDelete = v;
                        break;
                    case 'D7D':
                        this.masterCategoryListLastUpdate = new Date(v);
                        break;
                    case 'A1E':
                        this.maxAttachmentSize = v;
                        break;
                    case 'F85':
                        this.maxMailSendSize = v;
                        break;
                    case '811':
                        this.meRecipientId = new HxObjectID_1.default(v);
                        break;
                    case '119D':
                        this.mostRecentFindContactsBySearchStringInstrumentationId = new HxObjectID_1.default(v);
                        break;
                    case '119E':
                        this.mostRecentSearchContactsInstrumentationId = new HxObjectID_1.default(v);
                        break;
                    case '12C8':
                        this.mostRecentSearchPeopleForAddressingOfflineInstrumentationId = new HxObjectID_1.default(v);
                        break;
                    case '12C9':
                        this.mostRecentSearchPeopleForAddressingOnlineInstrumentationId = new HxObjectID_1.default(v);
                        break;
                    case 'F1E':
                        this.nextTimeToAskForCloudCacheCredentials = new Date(v);
                        break;
                    case 'F88':
                        this.nextTimeToInitializeDevice = new Date(v);
                        break;
                    case '15C2':
                        this.o365SubscriptionDetailsId = new HxObjectID_1.default(v);
                        break;
                    case 'C08':
                        this.o365SubscriptionStatus = v;
                        break;
                    case '1514':
                        this.oid = v;
                        break;
                    case 'D14':
                        this.oldRSAKeyTimestamp = new Date(v);
                        break;
                    case '7FA':
                        this.oneRMContentId = new HxObjectID_1.default(v);
                        break;
                    case '15AD':
                        this.onlineArchiveMailboxId = new HxObjectID_1.default(v);
                        break;
                    case '1534':
                        this.onPremisePortForCloudCache = v;
                        break;
                    case 'F38':
                        this.onPremiseUriForCloudCache = v;
                        break;
                    case '1078':
                        this.presenceCacheId = new HxObjectID_1.default(v);
                        break;
                    case '1119':
                        this.primaryAccountForSharedAccountId = new HxObjectID_1.default(v);
                        break;
                    case 'A20':
                        this.primarySmtp = v;
                        break;
                    case 'A21':
                        this.puid = v;
                        break;
                    case 'BAE':
                        this.pushNotificationSettings_BadgeCountClassification = v;
                        break;
                    case 'EBC':
                        this.pushNotificationSettings_CortanaEventAlertSound = v;
                        break;
                    case 'BB0':
                        this.pushNotificationSettings_NewMailClassification = v;
                        break;
                    case 'BB1':
                        this.pushNotificationSettings_Sound = v;
                        break;
                    case 'BC0':
                        this.pushNotificationSettings_WatermarkType = v;
                        break;
                    case 'B87':
                        this.readOnlyCalendarNotificationWatermarkCounter = v;
                        break;
                    case 'B88':
                        this.readOnlyCalendarNotificationWatermarkSessionId = v;
                        break;
                    case 'A6B':
                        this.readOnlyFirstSyncFinished = v;
                        break;
                    case '7AC':
                        this.readOnlyMailNotificationWatermarkCounter = v;
                        break;
                    case '7AD':
                        this.readOnlyMailNotificationWatermarkSessionId = v;
                        break;
                    case 'B02':
                        this.readOnlyOneRMContentLastAttemptedSyncTime = new Date(v);
                        break;
                    case 'A22':
                        this.recipientCacheLastUpdate = new Date(v);
                        break;
                    case '1187':
                        this.recipientsId = new HxObjectID_1.default(v);
                        break;
                    case 'A8D':
                        this.refreshToken = Buffer.from(v, 'base64');
                        break;
                    case 'AA8':
                        this.remappedServerIdsId = new HxObjectID_1.default(v);
                        break;
                    case '10E8':
                        this.remoteRefreshToken = Buffer.from(v, 'base64');
                        break;
                    case '14DD':
                        this.serviceSupportsSMIME = v;
                        break;
                    case '111B':
                        this.sharedAccountType = v;
                        break;
                    case 'A83':
                        this.smimePolicies_AlgorithmNegotiation = v;
                        break;
                    case 'A84':
                        this.smimePolicies_AllowSoftCertificates = v;
                        break;
                    case 'A85':
                        this.smimePolicies_AlwaysEncryptRequired = v;
                        break;
                    case 'A86':
                        this.smimePolicies_AlwaysSignRequired = v;
                        break;
                    case 'A87':
                        this.smimePolicies_RequiredEncryptingAlgorithm = v;
                        break;
                    case 'A88':
                        this.smimePolicies_RequiredSigningAlgorithm = v;
                        break;
                    case '3D8':
                        this.stableAccountId = v;
                        break;
                    case 'A24':
                        this.state = v;
                        break;
                    case 'F48':
                        this.suggestionSearchSessionsId = new HxObjectID_1.default(v);
                        break;
                    case '1168':
                        this.supportsAddIns = v;
                        break;
                    case 'D80':
                        this.supportsAllFoldersEnhancedMailSearch = v;
                        break;
                    case 'D81':
                        this.supportsAllFoldersStandardMailSearch = v;
                        break;
                    case '1412':
                        this.supportsAnswerSearch = v;
                        break;
                    case 'A26':
                        this.supportsAppendReplyHeaderOnTheServer = v;
                        break;
                    case 'A27':
                        this.supportsAtMentions = v;
                        break;
                    case 'A28':
                        this.supportsAttendeeAvailability = v;
                        break;
                    case 'EAC':
                        this.supportsAutomaticQuotedText = v;
                        break;
                    case 'BAC':
                        this.supportsBadgeCountPushNotification = v;
                        break;
                    case 'EB3':
                        this.supportsBinaryEncoding = v;
                        break;
                    case '10A0':
                        this.supportsBlockedSender = v;
                        break;
                    case '11A2':
                        this.supportsBlockingMeetingForward = v;
                        break;
                    case '1181':
                        this.supportsBottomWatermark = v;
                        break;
                    case 'A29':
                        this.supportsCalendarAttachments = v;
                        break;
                    case 'A2A':
                        this.supportsCalendarBodyFormatting = v;
                        break;
                    case '1113':
                        this.supportsCalendarCreate = v;
                        break;
                    case 'A2C':
                        this.supportsCalendarGroups = v;
                        break;
                    case 'A2D':
                        this.supportsCalendarSearch = v;
                        break;
                    case 'A2E':
                        this.supportsCalendarSharingOrganizationLabel = v;
                        break;
                    case 'E0A':
                        this.supportsCategories = v;
                        break;
                    case 'CD3':
                        this.supportsClientSideAppointmentExpansion = v;
                        break;
                    case 'D82':
                        this.supportsCloseSearchServiceCommand = v;
                        break;
                    case 'A2F':
                        this.supportsConnectors = v;
                        break;
                    case '1342':
                        this.supportsContactAgeCRUD = v;
                        break;
                    case '1343':
                        this.supportsContactAstrologySignCRUD = v;
                        break;
                    case '1344':
                        this.supportsContactBloodTypeCRUD = v;
                        break;
                    case '132B':
                        this.supportsContactCategoriesCRUD = v;
                        break;
                    case '13FA':
                        this.supportsContactCertificatesCRUD = v;
                        break;
                    case '1518':
                        this.supportsContactFetchByServerId = v;
                        break;
                    case '1345':
                        this.supportsContactInterestsCRUD = v;
                        break;
                    case 'A30':
                        this.supportsConversationalScheduling = v;
                        break;
                    case 'FD3':
                        this.supportsCopyMailItem = v;
                        break;
                    case 'A31':
                        this.supportsCreateFolder = v;
                        break;
                    case '11A5':
                        this.supportsCustomArchiveView = v;
                        break;
                    case 'EB5':
                        this.supportsDataReplication = v;
                        break;
                    case 'F91':
                        this.supportsDeferredSend = v;
                        break;
                    case '10ED':
                        this.supportsDelegates = v;
                        break;
                    case 'A33':
                        this.supportsDeleteFolder = v;
                        break;
                    case 'EE0':
                        this.supportsDlExpansion = v;
                        break;
                    case '102E':
                        this.supportsDoNotDisturb = v;
                        break;
                    case '1022':
                        this.supportsDraftsRoaming = v;
                        break;
                    case '1571':
                        this.supportsEditCalendarItemThisAndForward = v;
                        break;
                    case 'A34':
                        this.supportsEmptyFolder = v;
                        break;
                    case 'EC5':
                        this.supportsEmptySenderAlias = v;
                        break;
                    case 'A35':
                        this.supportsEnhancedSearch = v;
                        break;
                    case 'A36':
                        this.supportsEnhancedSearchTriage = v;
                        break;
                    case 'A37':
                        this.supportsExternalOOFMessage = v;
                        break;
                    case 'A38':
                        this.supportsExtractors = v;
                        break;
                    case 'A39':
                        this.supportsFamilyCalendars = v;
                        break;
                    case '15B3':
                        this.supportsFileSearch = v;
                        break;
                    case 'A3A':
                        this.supportsFirstDayOfWeekForRepeatExpansion = v;
                        break;
                    case 'A3B':
                        this.supportsFocusedInbox = v;
                        break;
                    case 'A3C':
                        this.supportsForwardMeetings = v;
                        break;
                    case 'A3D':
                        this.supportsFragmentedConversation = v;
                        break;
                    case 'A3E':
                        this.supportsGalPhotos = v;
                        break;
                    case 'A3F':
                        this.supportsGalSearch = v;
                        break;
                    case 'EB2':
                        this.supportsGloomProviderCalendarSync = v;
                        break;
                    case 'C7B':
                        this.supportsGroups = v;
                        break;
                    case 'F2B':
                        this.supportsGroupsCalendar = v;
                        break;
                    case 'DAF':
                        this.supportsGroupsCreation = v;
                        break;
                    case 'EA2':
                        this.supportsHeterogeneousFavorites = v;
                        break;
                    case 'A40':
                        this.supportsIdentifyingSpecialFolders = v;
                        break;
                    case 'A69':
                        this.supportsIgnore = v;
                        break;
                    case 'E7F':
                        this.supportsImageApi = v;
                        break;
                    case 'C09':
                        this.supportsImplicitChildFolderDelete = v;
                        break;
                    case '1508':
                        this.supportsImplicitOriginDownloadForReply = v;
                        break;
                    case '1636':
                        this.supportsImportEmlToMesageList = v;
                        break;
                    case 'A41':
                        this.supportsInboxRules = v;
                        break;
                    case 'B59':
                        this.supportsInContextSearchFeedback = v;
                        break;
                    case 'E50':
                        this.supportsIncrementalCalendarUpdates = v;
                        break;
                    case 'DF8':
                        this.supportsIncrementalDraftUpdates = v;
                        break;
                    case '112A':
                        this.supportsInferredLocation = v;
                        break;
                    case 'A42':
                        this.supportsInterestingCalendars = v;
                        break;
                    case 'A43':
                        this.supportsInternalOOFMessage = v;
                        break;
                    case 'A44':
                        this.supportsIRM = v;
                        break;
                    case 'A45':
                        this.supportsJunkMail = v;
                        break;
                    case '1416':
                        this.supportsLegacyMailSearch = v;
                        break;
                    case '1417':
                        this.supportsLegacyPeopleSearch = v;
                        break;
                    case 'A47':
                        this.supportsLocationSuggestions = v;
                        break;
                    case '1033':
                        this.supportsMarkAsPhishing = v;
                        break;
                    case '1314':
                        this.supportsMarkingContactPrivate = v;
                        break;
                    case '12D1':
                        this.supportsMeetingDrafts = v;
                        break;
                    case 'A49':
                        this.supportsMeetings = v;
                        break;
                    case 'A4A':
                        this.supportsMeetingTimeCandidates = v;
                        break;
                    case 'EB6':
                        this.supportsMessageCleanup = v;
                        break;
                    case 'F8C':
                        this.supportsMessagePreviewGeneration = v;
                        break;
                    case '1444':
                        this.supportsMessageReactions = v;
                        break;
                    case 'E78':
                        this.supportsMessageSections = v;
                        break;
                    case '1548':
                        this.supportsMimeFetch = v;
                        break;
                    case '1135':
                        this.supportsMipLabels = v;
                        break;
                    case 'A4B':
                        this.supportsModernConversations = v;
                        break;
                    case 'B15':
                        this.supportsMoreMessageHeaders = v;
                        break;
                    case 'A4C':
                        this.supportsMoveFolder = v;
                        break;
                    case 'C29':
                        this.supportsMoveToJunk = v;
                        break;
                    case '145C':
                        this.supportsNonAlphabeticalViewSort = v;
                        break;
                    case 'A4D':
                        this.supportsNonGregorianCalendars = v;
                        break;
                    case 'A4E':
                        this.supportsNPR = v;
                        break;
                    case '1369':
                        this.supportsOnBehalfOf = v;
                        break;
                    case 'F89':
                        this.supportsOneRM = v;
                        break;
                    case '15AE':
                        this.supportsOnlineArchiveMailbox = v;
                        break;
                    case '136B':
                        this.supportsOnlineTopSearch = v;
                        break;
                    case '1538':
                        this.supportsPinMailItemActions = v;
                        break;
                    case 'A50':
                        this.supportsPostalAddressEntity = v;
                        break;
                    case '1185':
                        this.supportsPresence = v;
                        break;
                    case 'D83':
                        this.supportsPrewarmSearch = v;
                        break;
                    case '1274':
                        this.supportsPrewarmSearchServiceCommand = v;
                        break;
                    case '1290':
                        this.supportsPushNotifications = v;
                        break;
                    case 'EAA':
                        this.supportsRecipientCacheSyncing = v;
                        break;
                    case '12B0':
                        this.supportsRemindersOnServer = v;
                        break;
                    case '134A':
                        this.supportsRemoteSharedCalendars = v;
                        break;
                    case 'A52':
                        this.supportsRemoveCalendar = v;
                        break;
                    case 'A53':
                        this.supportsRemoveFromCalendar = v;
                        break;
                    case 'A54':
                        this.supportsRenameFolder = v;
                        break;
                    case '159C':
                        this.supportsReportAbuse = v;
                        break;
                    case '1320':
                        this.supportsReportSearchInstrumentation = v;
                        break;
                    case '1266':
                        this.supportsReportToMicrosoft = v;
                        break;
                    case 'A55':
                        this.supportsRespondToMeetings = v;
                        break;
                    case '13B3':
                        this.supportsRestApi = v;
                        break;
                    case 'A56':
                        this.supportsRichContent = v;
                        break;
                    case 'A57':
                        this.supportsRoamingFavoriteFolders = v;
                        break;
                    case 'A58':
                        this.supportsRoomFinder = v;
                        break;
                    case '11F2':
                        this.supportsSaveSentMail = v;
                        break;
                    case 'F3F':
                        this.supportsSeamlessSend = v;
                        break;
                    case '1302':
                        this.supportsSearchAttachments = v;
                        break;
                    case 'A59':
                        this.supportsSearchMessageHeadersFetch = v;
                        break;
                    case '1303':
                        this.supportsSearchRecentAttachments = v;
                        break;
                    case 'A5A':
                        this.supportsSearchSuggestions = v;
                        break;
                    case 'F9F':
                        this.supportsSendDeliveryReceipt = v;
                        break;
                    case 'A5B':
                        this.supportsSendNewTimeProposals = v;
                        break;
                    case 'FA0':
                        this.supportsSendReadReceipt = v;
                        break;
                    case '1023':
                        this.supportsSentItemsView = v;
                        break;
                    case '1316':
                        this.supportsServerCalculatedBadgeCount = v;
                        break;
                    case '1034':
                        this.supportsSmartCalendarReply = v;
                        break;
                    case 'A5C':
                        this.supportsSmartReply = v;
                        break;
                    case '14DE':
                        this.supportsSMIME = v;
                        break;
                    case 'BC3':
                        this.supportsSoftFolderDelete = v;
                        break;
                    case '1024':
                        this.supportsSoftMessageItemDelete = v;
                        break;
                    case '1418':
                        this.supportsSubstrateCalendarSearch = v;
                        break;
                    case '1419':
                        this.supportsSubstrateCalendarSearchWithRequestV2 = v;
                        break;
                    case '141A':
                        this.supportsSubstrateMailSearch = v;
                        break;
                    case '141B':
                        this.supportsSubstrateMailSearchWithRequestV2 = v;
                        break;
                    case '141C':
                        this.supportsSubstratePeopleSearch = v;
                        break;
                    case '50':
                        this.supportsSyncSettingsUI = v;
                        break;
                    case '1350':
                        this.supportsToDo = v;
                        break;
                    case 'B48':
                        this.supportsTopResultsSearch = v;
                        break;
                    case 'A61':
                        this.supportsTriageArchive = v;
                        break;
                    case 'A62':
                        this.supportsTriageDelete = v;
                        break;
                    case 'A63':
                        this.supportsTriageFlag = v;
                        break;
                    case 'A64':
                        this.supportsTriageMove = v;
                        break;
                    case 'C2C':
                        this.supportsTriageSchedule = v;
                        break;
                    case 'A65':
                        this.supportsTriageUnread = v;
                        break;
                    case '1321':
                        this.supportsUnknownViewOnSearchOwnedMessageHeaders = v;
                        break;
                    case '1466':
                        this.supportsUserDisplayNameChange = v;
                        break;
                    case 'FB4':
                        this.supportsViewServerIdChange = v;
                        break;
                    case 'A66':
                        this.supportsWorkingElsewhere = v;
                        break;
                    case '1449':
                        this.supportsWorkspaceBooking = v;
                        break;
                    case '61F':
                        this.syncSettings_ActiveSyncDomain = v;
                        break;
                    case '61E':
                        this.syncSettings_AuthType = v;
                        break;
                    case 'A82':
                        this.syncSettings_AutoDetectFeedbackCookie = v;
                        break;
                    case '625':
                        this.syncSettings_CreationState = v;
                        break;
                    case '62A':
                        this.syncSettings_EmailSyncWindow = v;
                        break;
                    case '823':
                        this.syncSettings_ExchangeForest = v;
                        break;
                    case '1386':
                        this.syncSettings_IncomingServerAddress = v;
                        break;
                    case 'F8D':
                        this.syncSettings_IncomingServerPassword = Buffer.from(v, 'base64');
                        break;
                    case '1387':
                        this.syncSettings_IncomingServerPort = v;
                        break;
                    case '15A7':
                        this.syncSettings_IncomingServerSslScheme = v;
                        break;
                    case '61C':
                        this.syncSettings_IncomingServerUsername = v;
                        break;
                    case '1389':
                        this.syncSettings_OutgoingServerAddress = v;
                        break;
                    case '623':
                        this.syncSettings_OutgoingServerAuthenticationRequired = v;
                        break;
                    case 'F8E':
                        this.syncSettings_OutgoingServerPassword = Buffer.from(v, 'base64');
                        break;
                    case '138A':
                        this.syncSettings_OutgoingServerPort = v;
                        break;
                    case '15A8':
                        this.syncSettings_OutgoingServerSslScheme = v;
                        break;
                    case '622':
                        this.syncSettings_OutgoingServerUsername = v;
                        break;
                    case '131E':
                        this.syncSettings_PopLeaveOnServer = v;
                        break;
                    case '1331':
                        this.syncSettings_SslCertificateValidation = v;
                        break;
                    case '626':
                        this.syncSettings_SyncDeviceAccountTypeId = v;
                        break;
                    case '627':
                        this.syncSettings_SyncFrequency = v;
                        break;
                    case '628':
                        this.syncSettings_SyncFrequencyPollMinutes = v;
                        break;
                    case '61D':
                        this.syncSettings_WebAccountId = v;
                        break;
                    case 'AD0':
                        this.tenantGuid = v;
                        break;
                    case '1351':
                        this.toDoId = new HxObjectID_1.default(v);
                        break;
                    case '609':
                        this.truncateMessages = v;
                        break;
                    case '33':
                        this.type = v;
                        break;
                    case '80E':
                        this.uiOrder = v;
                        break;
                    case '358':
                        this.uniqueAccountId = v;
                        break;
                    case '359':
                        this.uniqueAccountType = v;
                        break;
                    case '619':
                        this.userDisplayName = v;
                        break;
                    case 'E5F':
                        this.userPrincipalName = v;
                        break;
                    case '15DF':
                        this.userSettingsId = new HxObjectID_1.default(v);
                        break;
                    case 'A6F':
                        this.userSettingsLastUpdateTime = new Date(v);
                        break;
                    case 'A67':
                        this.webAccountId = v;
                        break;
                    case 'A90':
                        this.webDavServerInfo_CalendarPrincipalUri = v;
                        break;
                    case 'D2F':
                        this.webDavServerInfo_CardPrincipalUri = v;
                        break;
                }
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_1) throw e_1.error; }
        }
    };
    HxAccount.prototype.getAadLogoDark = function (sessionId) {
        return this.activeSet.getObject(this.aadLogoDarkId, sessionId).then(function (result) { return result; });
    };
    HxAccount.prototype.getAadLogoLight = function (sessionId) {
        return this.activeSet.getObject(this.aadLogoLightId, sessionId).then(function (result) { return result; });
    };
    HxAccount.prototype.getActivityFeedData = function (sessionId) {
        return this.activeSet.getCollection(this.activityFeedDataId, sessionId);
    };
    HxAccount.prototype.getAddIns = function (sessionId) {
        return this.activeSet.getCollection(this.addInsId, sessionId);
    };
    HxAccount.prototype.getAttachments = function (sessionId) {
        return this.activeSet.getCollection(this.attachmentsId, sessionId);
    };
    HxAccount.prototype.getBlockedSendersAndDomains = function (sessionId) {
        return this.activeSet.getCollection(this.blockedSendersAndDomainsId, sessionId);
    };
    HxAccount.prototype.getCalendar = function (sessionId) {
        return this.activeSet.getObject(this.calendarId, sessionId).then(function (result) { return result; });
    };
    HxAccount.prototype.getCategories = function (sessionId) {
        return this.activeSet.getCollection(this.categoriesId, sessionId);
    };
    HxAccount.prototype.getContact = function (sessionId) {
        return this.activeSet.getObject(this.contactId, sessionId).then(function (result) { return result; });
    };
    HxAccount.prototype.getDelegateUsers = function (sessionId) {
        return this.activeSet.getCollection(this.delegateUsersId, sessionId);
    };
    HxAccount.prototype.getEasPolicies = function (sessionId) {
        return this.activeSet.getObject(this.easPoliciesId, sessionId).then(function (result) { return result; });
    };
    HxAccount.prototype.getErrors = function (sessionId) {
        return this.activeSet.getCollection(this.errorsId, sessionId);
    };
    HxAccount.prototype.getFavoriteItems = function (sessionId) {
        return this.activeSet.getCollection(this.favoriteItemsId, sessionId);
    };
    HxAccount.prototype.getFirstSync = function (sessionId) {
        return this.activeSet.getObject(this.firstSyncId, sessionId).then(function (result) { return result; });
    };
    HxAccount.prototype.getGroups = function (sessionId) {
        return this.activeSet.getCollection(this.groupsId, sessionId);
    };
    HxAccount.prototype.getGroupSettings = function (sessionId) {
        return this.activeSet.getObject(this.groupSettingsId, sessionId).then(function (result) { return result; });
    };
    HxAccount.prototype.getLdapServerSettings = function (sessionId) {
        return this.activeSet.getCollection(this.ldapServerSettingsId, sessionId);
    };
    HxAccount.prototype.getMail = function (sessionId) {
        return this.activeSet.getObject(this.mailId, sessionId).then(function (result) { return result; });
    };
    HxAccount.prototype.getMailSubscriptionList = function (sessionId) {
        return this.activeSet.getCollection(this.mailSubscriptionListId, sessionId);
    };
    HxAccount.prototype.getMeRecipient = function (sessionId) {
        return this.activeSet.getObject(this.meRecipientId, sessionId).then(function (result) { return result; });
    };
    HxAccount.prototype.getMostRecentFindContactsBySearchStringInstrumentation = function (sessionId) {
        return this.activeSet.getObject(this.mostRecentFindContactsBySearchStringInstrumentationId, sessionId).then(function (result) { return result; });
    };
    HxAccount.prototype.getMostRecentSearchContactsInstrumentation = function (sessionId) {
        return this.activeSet.getObject(this.mostRecentSearchContactsInstrumentationId, sessionId).then(function (result) { return result; });
    };
    HxAccount.prototype.getMostRecentSearchPeopleForAddressingOfflineInstrumentation = function (sessionId) {
        return this.activeSet.getObject(this.mostRecentSearchPeopleForAddressingOfflineInstrumentationId, sessionId).then(function (result) { return result; });
    };
    HxAccount.prototype.getMostRecentSearchPeopleForAddressingOnlineInstrumentation = function (sessionId) {
        return this.activeSet.getObject(this.mostRecentSearchPeopleForAddressingOnlineInstrumentationId, sessionId).then(function (result) { return result; });
    };
    HxAccount.prototype.getO365SubscriptionDetails = function (sessionId) {
        return this.activeSet.getObject(this.o365SubscriptionDetailsId, sessionId).then(function (result) { return result; });
    };
    HxAccount.prototype.getOneRMContent = function (sessionId) {
        return this.activeSet.getObject(this.oneRMContentId, sessionId).then(function (result) { return result; });
    };
    HxAccount.prototype.getOnlineArchiveMailbox = function (sessionId) {
        return this.activeSet.getObject(this.onlineArchiveMailboxId, sessionId).then(function (result) { return result; });
    };
    HxAccount.prototype.getPresenceCache = function (sessionId) {
        return this.activeSet.getCollection(this.presenceCacheId, sessionId);
    };
    HxAccount.prototype.getPrimaryAccountForSharedAccount = function (sessionId) {
        return this.activeSet.getObject(this.primaryAccountForSharedAccountId, sessionId).then(function (result) { return result; });
    };
    HxAccount.prototype.getRecipients = function (sessionId) {
        return this.activeSet.getCollection(this.recipientsId, sessionId);
    };
    HxAccount.prototype.getRemappedServerIds = function (sessionId) {
        return this.activeSet.getCollection(this.remappedServerIdsId, sessionId);
    };
    HxAccount.prototype.getSuggestionSearchSessions = function (sessionId) {
        return this.activeSet.getCollection(this.suggestionSearchSessionsId, sessionId);
    };
    HxAccount.prototype.getToDo = function (sessionId) {
        return this.activeSet.getObject(this.toDoId, sessionId).then(function (result) { return result; });
    };
    HxAccount.prototype.getUserSettings = function (sessionId) {
        return this.activeSet.getObject(this.userSettingsId, sessionId).then(function (result) { return result; });
    };
    return HxAccount;
}(HxObject_1.default));
exports.HxAccount = HxAccount;
exports.default = HxAccount;
